import { render, staticRenderFns } from "./Wcp.vue?vue&type=template&id=581f2bb0"
import script from "./Wcp.vue?vue&type=script&lang=js"
export * from "./Wcp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports